import React from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    Checkbox,
    FormControlLabel,
    Grid,
    Link,
    Modal,
    Typography,
} from '@mui/material';
import { usePqrWebForm } from '../hooks';
import { AccountContactPerson } from '../../accounts/form/contactPerson';
import { AccountAddress } from '../../accounts/form/address';
import { AccountSpecialCondition } from '../../accounts/form/specialCondition';
import { PqrWebInfo } from './info';
import { PqrAttachment } from '../../pqr/form/attachment';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { ModalCreate } from './modalCreate';
import { PqrWebResponseMedium } from './responseMedium';
import { LayoutPqrWeb } from '../../../../layout/pqr_web';

export const PqrWebCreate = () => {
    const {
        loading,
        handleFormSubmit,
        handleClean,
        handleOpen,
        handleClose,
        open,
        showForm,
        consecutiveFormat,
        formikPqrInfoWeb,
        setFormikContactPerson,
        setFormikSpecialCondition,
        setFormikPqrInfoWeb,
        setFormikAddress,
        setFormikPqrResponseMedium,
    } = usePqrWebForm();

    return (
        <>
            <LayoutPqrWeb title="Crear - RADICAR PQR" />
            {showForm ? (
                <Box mt={10}>
                    <AccountContactPerson
                        onChangeFormik={(formik) =>
                            setFormikContactPerson(formik)
                        }
                    />
                    <AccountAddress
                        onChangeFormik={(formik) => setFormikAddress(formik)}
                    />
                    <AccountSpecialCondition
                        onChangeFormik={(formik) =>
                            setFormikSpecialCondition(formik)
                        }
                    />
                    <PqrWebInfo
                        onChangeFormik={(formik) => setFormikPqrInfoWeb(formik)}
                    />
                    <PqrWebResponseMedium
                        onChangeFormik={(formik) =>
                            setFormikPqrResponseMedium(formik)
                        }
                    />
                    <PqrAttachment />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={formikPqrInfoWeb?.values.acceptTerms}
                                onChange={(e) =>
                                    formikPqrInfoWeb?.setFieldValue(
                                        'acceptTerms',
                                        e.target.checked
                                    )
                                }
                                required
                            />
                        }
                        label={
                            <label onClick={handleOpen} className="link-button">
                                Acepto tratamiento de datos personales
                            </label>
                        }
                    />
                    <Typography variant="body2">
                        Al hacer clic el botón enviar, usted acepta la remisión
                        de la PQR a la Previsora S.A Compañía de Seguros. Sus
                        datos serán recolectados y tratados conforme con la
                        Política de Tratamiento de Datos. En la opción consulta
                        de PQRSD podrá verificar el estado de la respuesta.
                        <br />
                        <br />
                        En caso que la solicitud de información sea de
                        naturaleza de identidad reservada, deberá efectuar el
                        respectivo trámite ante la Procuraduría General de la
                        Nación, haciendo clic en el siguiente link:{' '}
                        <Link
                            href="https://sedeelectronica.procuraduria.gov.co/"
                            target="_blanck"
                        >
                            solicitud_informacion_identificacion_reservada
                        </Link>
                        <br />
                        <br />
                        En caso de requerir radicar una denuncia anónima por
                        favor dirigirse al siguiente link:{' '}
                        <Link
                            href="https://www.previsora.gov.co/web/guest/linea-etica"
                            target="_blanck"
                        >
                            linea etica
                        </Link>
                    </Typography>
                    <Grid item xs={12} mt={5} mb={10}>
                        <LoadingButtonGeneral
                            disabled={loading}
                            loading={loading}
                            title="Guardar"
                            sx={{ mr: 1 }}
                            onClick={handleFormSubmit}
                        />
                        <LoadingButtonGeneral
                            disabled={loading}
                            title="Limpiar"
                            variant="outlined"
                            onClick={handleClean}
                        />
                    </Grid>
                    <Box
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                        }}
                    >
                        <Typography
                            variant="caption"
                            style={{ fontSize: '0.875rem', color: '#666' }}
                        >
                            Powered by Comware
                        </Typography>
                    </Box>
                    <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                    >
                        <Box
                            className="modal-card-container"
                            sx={{
                                width: '70%',
                                maxHeight: '50%',
                                top: '30%',
                            }}
                        >
                            <Card className="modal-card">
                                <CardContent>
                                    <Typography
                                        id="modal-title"
                                        variant="h6"
                                        component="h2"
                                        className="modal-card-title"
                                    >
                                        Autorización Datos Personales
                                    </Typography>
                                    <Typography
                                        id="modal-description"
                                        variant="body2"
                                        component="p"
                                        className="modal-card-content"
                                        sx={{
                                            maxHeight: '60vh',
                                            overflowY: 'auto',
                                            padding: '0.5rem',
                                        }}
                                    >
                                        Autorizo expresamente a La Previsora
                                        S.A, Compañía de Seguros con NIT.
                                        860002400-2 como responsable del
                                        tratamiento de la información, para
                                        utilizar nombre, teléfono de contacto,
                                        correo electrónico y demás datos
                                        personales compartidos con la compañía
                                        por medio de este formulario con el fin
                                        de :
                                        <br />
                                        <br />
                                        a) Realizar gestiones de conocimiento al
                                        cliente y verificación o actualización
                                        de información a través de correo
                                        electrónico, mensajes de texto MMS/SMS
                                        y/o telefónicamente; b) Tramitar mis
                                        solicitudes o recibir información
                                        general sobre automóviles, SOAT, hogar,
                                        áreas comunes y otros ramos c) Enviar
                                        correspondencia, correos electrónico,
                                        mensajes de texto (SMS) o hacer contacto
                                        telefónico en desarrollo de actividades
                                        publicitarias, de mercadeo, ofrecimiento
                                        de productos o servicios nuevos y
                                        actuales considerados de su interés; d)
                                        Compartir esta información con terceros
                                        conforme se haga necesario para realizar
                                        actividades comprendidas dentro de su
                                        objeto social y/o para el ejercicio de
                                        actividades relacionadas con estas
                                        mismas finalidades; e) Realizar
                                        encuestas de satisfacción y percepción
                                        sobre los productos y servicios de la
                                        compañía por cualquier medio; f) Para la
                                        prestación de todos los servicios
                                        convenidos dentro del contrato de
                                        seguros en caso que tenga la calidad de
                                        asegurado o beneficiario; g) atender
                                        requerimientos de autoridades en
                                        ejercicio de sus funciones; h)
                                        conservarla para fines históricos y/o
                                        estadísticos. Especialmente declaro que
                                        he recibido información sobre el
                                        carácter facultativo de la respuesta a
                                        las preguntas que me sean efectuadas,
                                        cuando estas versen sobre datos
                                        sensibles o sobre datos de niñas, niños
                                        y adolescentes, y que de acuerdo con la
                                        legislación colombiana vigente en
                                        materia de protección de datos
                                        personales, como titular de la
                                        información tengo derecho a conocer,
                                        actualizar, rectificar y suprimir mis
                                        datos personales, esto último, en caso
                                        de ser posible, al no mediar una
                                        relación contractual o legal que impida
                                        el retiro de la información, enviando
                                        solicitud al correo electrónico
                                        contactenos@previsora.gov.co, enviando
                                        comunicación escrita a la Calle 57 # 9 –
                                        07 en Bogotá, en el teléfono 3487555 o a
                                        través del sistema PQR disponible en la
                                        página WEB www.previsora.gov.co.
                                        <br />
                                        <br />
                                        Que como titular de los datos me asisten
                                        los derechos establecidos en la ley 1581
                                        de 2012 y sus Decretos reglamentarios o
                                        demás normas que la modifiquen,
                                        adicionen o complementen, en especial
                                        los derechos a: a) Conocer, actualizar y
                                        rectificar mis datos b) Solicitar prueba
                                        de la autorización otorgada; c) Ser
                                        informado del uso que le ha dado a sus
                                        datos personales; d) Presentar ante la
                                        Superintendencia de Industria y Comercio
                                        quejas por infracciones a las
                                        disposiciones legales vigentes e)
                                        Revocar la autorización y/o solicitar la
                                        supresión del dato cuando en el
                                        Tratamiento no se respeten los
                                        principios, derechos y garantías
                                        constitucionales y legales. f) Acceder
                                        en forma gratuita a mis datos personales
                                        que hayan sido objeto de Tratamiento al
                                        menos una vez cada mes calendario y cada
                                        vez que existan modificaciones
                                        sustanciales de las Políticas de
                                        Tratamiento de la información que
                                        motiven nuevas consultas. Dejo
                                        constancia que se me ha suministrado
                                        información comprensible en torno a mis
                                        derechos referentes con el tratamiento
                                        de mi información personal, en
                                        particular el de presentar consultas,
                                        peticiones y quejas. Para más
                                        información sobre la Política de
                                        privacidad de la compañía, así como los
                                        derechos de los titulares de la
                                        información y la manera de ejercerlos es
                                        posible acceder a la página de internet
                                        www.previsora.gov.co
                                    </Typography>
                                    <Box
                                        sx={{
                                            textAlign: 'right',
                                            mt: 3,
                                        }}
                                    >
                                        <Button
                                            variant="contained"
                                            className="modal-card-button"
                                            onClick={handleClose}
                                        >
                                            Acepto
                                        </Button>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>
                    </Modal>
                </Box>
            ) : (
                <ModalCreate
                    open={Boolean(!showForm)}
                    title="Apreciado Cliente"
                    consecutiveFormat={consecutiveFormat}
                />
            )}
        </>
    );
};
